'use strict';

import $ from 'jquery';
import axios from 'axios';

const origin = window.location.pathname;
const path = '/getMoreArticles';

let NewsLoader = function ($el, opts) {
    this.$el = $el;
    this.opts = $.extend(true, {}, NewsLoader.defaults, this.$el.data(), opts || {});
    this.quantityToLoad = parseInt($el.data('load-quantity')) || NewsLoader.defaults.quantityToLoad;

    this.$articles = this.$el.find('[data-section="all-articles"]');
    this.$errors = this.$el.find('[data-type="errors"]');
    this.$submit = this.$el.find('button[data-action="submit"]');

    this.init();
};

NewsLoader.prototype.init = function () {

    /**
     * Register Event handlers here
     */
    this.$submit.on('click', () => {
        this.getArticles();
        return false;
    });

};

NewsLoader.prototype.getArticles = function () {

    const ENDPOINT = origin.concat(path);

    axios.get(ENDPOINT, {
        params: {
            lastId: this.$articles.children().last().data('id'),
            quantity: this.quantityToLoad
        },
        header: {
            'Content-Type': 'application/json; charset=utf-8'
        }
    }).then(function (response) {

        let articles = response.data;

        switch (response.status) {

            case 200: // All articles requested will be returned
                this.appendArticles(articles);
                break;

            case 204: // No articles have been returned
                this.hideLoader(NewsLoader.defaults.hideMessage, true);
                break;

            case 206: // Only some of the articles will be returned
                this.appendArticles(articles);
                this.hideLoader(NewsLoader.defaults.hideMessage, true);
                break;

            default:
                break;
        }

    }.bind(this)).catch(function (error) {
        this.hideLoader(error.message, true);
    }.bind(this));

    return false;
};

NewsLoader.prototype.appendArticles = function (articles) {

    articles.forEach((article) => {
        const articleMarkup = this.buildArticleHtml(article);
        this.$articles.append(articleMarkup);
    })

};

NewsLoader.prototype.buildArticleHtml = function (article) {
    return (
        '<li class="col-24" data-id="' + article.id + '">' +
            '<a href="' + article.link + '">' +
        '<div class="article">' +
        '<h6>' + article.title + '</h6>' +
        '<p class="date">' + article.createdAt +'</p>' +
        '</div>' +
        '</a>' +
        '</li>'
    );
};

NewsLoader.prototype.hideLoader = function (message, hideLoader) {

    this.$errors.html('<p>' + message + '</p>').fadeIn();

    if(hideLoader) {
        this.$submit.fadeOut();
    }

};

NewsLoader.defaults = {
    quantityToLoad: 3,
    hideMessage: 'No more news articles to load',
    errorMessage: 'No articles could be found, try refreshing and trying again.'
};

NewsLoader.init = function ($scope) {
    $($scope || '[data-type="news-section"]').each(function (i, el) {
        return new NewsLoader($(el));
    }.bind(this));
};

export default NewsLoader;